import React, { createContext, useContext, useState } from 'react'

interface AmplifyContextType {
  isConfigured: boolean
  isLoading: boolean
  error: string | null
  setConfigured: (configured: boolean) => void
  setError: (error: string | null) => void
}

const AmplifyContext = createContext<AmplifyContextType | undefined>(undefined)

export function AmplifyProvider({ children }: { children: React.ReactNode }) {
  const [isConfigured, setIsConfigured] = useState(false)
  const [isLoading] = useState(false) // No longer loading since we wait for tenant
  const [error, setError] = useState<string | null>(null)

  const setConfigured = (configured: boolean) => {
    setIsConfigured(configured)
    if (configured && error) {
      setError(null) // Clear any previous errors when successfully configured
    }
  }

  const value: AmplifyContextType = {
    isConfigured,
    isLoading,
    error,
    setConfigured,
    setError
  }

  return (
    <AmplifyContext.Provider value={value}>
      {children}
    </AmplifyContext.Provider>
  )
}

export function useAmplify() {
  const context = useContext(AmplifyContext)
  if (context === undefined) {
    throw new Error('useAmplify must be used within an AmplifyProvider')
  }
  return context
} 